/* tslint:disable */
/* eslint-disable */
/**
 * compass-pro
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PvdConfigurationOnAzure
 */
export interface PvdConfigurationOnAzure {
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    org_code: string;
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    spec_name: string;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    is_compass_core: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    readonly voltage_disable_allowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    readonly current_disable_allowed: boolean;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof PvdConfigurationOnAzure
     */
    voltage_allowed_settings: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_voltage_allowed: boolean;
    /**
     * 
     * @type {Array<boolean>}
     * @memberof PvdConfigurationOnAzure
     */
    current_allowed_settings: Array<boolean>;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_current_allowed: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_shared_auto_adapt_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_shared_auto_adapt_locked_to_value: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_voltage_next_alert_size_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_voltage_next_alert_size_locked_to_value: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_current_next_alert_size_is_locked: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_current_next_alert_size_locked_to_value: boolean;
    /**
     * 
     * @type {number}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_voltage_max_setting: number;
    /**
     * 
     * @type {number}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_voltage_min_setting: number;
    /**
     * 
     * @type {number}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_current_max_setting: number;
    /**
     * 
     * @type {number}
     * @memberof PvdConfigurationOnAzure
     */
    adaptive_current_min_setting: number;
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    object_type: string;
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    readonly unique_key: string;
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    id: string;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    should_force_apply: boolean;
    /**
     * 
     * @type {string}
     * @memberof PvdConfigurationOnAzure
     */
    _etag: string;
    /**
     * 
     * @type {number}
     * @memberof PvdConfigurationOnAzure
     */
    _ts: number;
    /**
     * 
     * @type {boolean}
     * @memberof PvdConfigurationOnAzure
     */
    readonly is_base_config: boolean;
}

/**
 * Check if a given object implements the PvdConfigurationOnAzure interface.
 */
export function instanceOfPvdConfigurationOnAzure(value: object): value is PvdConfigurationOnAzure {
    if (!('org_code' in value) || value['org_code'] === undefined) return false;
    if (!('spec_name' in value) || value['spec_name'] === undefined) return false;
    if (!('is_compass_core' in value) || value['is_compass_core'] === undefined) return false;
    if (!('voltage_disable_allowed' in value) || value['voltage_disable_allowed'] === undefined) return false;
    if (!('current_disable_allowed' in value) || value['current_disable_allowed'] === undefined) return false;
    if (!('voltage_allowed_settings' in value) || value['voltage_allowed_settings'] === undefined) return false;
    if (!('adaptive_voltage_allowed' in value) || value['adaptive_voltage_allowed'] === undefined) return false;
    if (!('current_allowed_settings' in value) || value['current_allowed_settings'] === undefined) return false;
    if (!('adaptive_current_allowed' in value) || value['adaptive_current_allowed'] === undefined) return false;
    if (!('adaptive_shared_auto_adapt_is_locked' in value) || value['adaptive_shared_auto_adapt_is_locked'] === undefined) return false;
    if (!('adaptive_shared_auto_adapt_locked_to_value' in value) || value['adaptive_shared_auto_adapt_locked_to_value'] === undefined) return false;
    if (!('adaptive_voltage_next_alert_size_is_locked' in value) || value['adaptive_voltage_next_alert_size_is_locked'] === undefined) return false;
    if (!('adaptive_voltage_next_alert_size_locked_to_value' in value) || value['adaptive_voltage_next_alert_size_locked_to_value'] === undefined) return false;
    if (!('adaptive_current_next_alert_size_is_locked' in value) || value['adaptive_current_next_alert_size_is_locked'] === undefined) return false;
    if (!('adaptive_current_next_alert_size_locked_to_value' in value) || value['adaptive_current_next_alert_size_locked_to_value'] === undefined) return false;
    if (!('adaptive_voltage_max_setting' in value) || value['adaptive_voltage_max_setting'] === undefined) return false;
    if (!('adaptive_voltage_min_setting' in value) || value['adaptive_voltage_min_setting'] === undefined) return false;
    if (!('adaptive_current_max_setting' in value) || value['adaptive_current_max_setting'] === undefined) return false;
    if (!('adaptive_current_min_setting' in value) || value['adaptive_current_min_setting'] === undefined) return false;
    if (!('object_type' in value) || value['object_type'] === undefined) return false;
    if (!('unique_key' in value) || value['unique_key'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('should_force_apply' in value) || value['should_force_apply'] === undefined) return false;
    if (!('_etag' in value) || value['_etag'] === undefined) return false;
    if (!('_ts' in value) || value['_ts'] === undefined) return false;
    if (!('is_base_config' in value) || value['is_base_config'] === undefined) return false;
    return true;
}

export function PvdConfigurationOnAzureFromJSON(json: any): PvdConfigurationOnAzure {
    return PvdConfigurationOnAzureFromJSONTyped(json, false);
}

export function PvdConfigurationOnAzureFromJSONTyped(json: any, ignoreDiscriminator: boolean): PvdConfigurationOnAzure {
    if (json == null) {
        return json;
    }
    return {
        
        'org_code': json['org_code'],
        'spec_name': json['spec_name'],
        'is_compass_core': json['is_compass_core'],
        'voltage_disable_allowed': json['voltage_disable_allowed'],
        'current_disable_allowed': json['current_disable_allowed'],
        'voltage_allowed_settings': json['voltage_allowed_settings'],
        'adaptive_voltage_allowed': json['adaptive_voltage_allowed'],
        'current_allowed_settings': json['current_allowed_settings'],
        'adaptive_current_allowed': json['adaptive_current_allowed'],
        'adaptive_shared_auto_adapt_is_locked': json['adaptive_shared_auto_adapt_is_locked'],
        'adaptive_shared_auto_adapt_locked_to_value': json['adaptive_shared_auto_adapt_locked_to_value'],
        'adaptive_voltage_next_alert_size_is_locked': json['adaptive_voltage_next_alert_size_is_locked'],
        'adaptive_voltage_next_alert_size_locked_to_value': json['adaptive_voltage_next_alert_size_locked_to_value'],
        'adaptive_current_next_alert_size_is_locked': json['adaptive_current_next_alert_size_is_locked'],
        'adaptive_current_next_alert_size_locked_to_value': json['adaptive_current_next_alert_size_locked_to_value'],
        'adaptive_voltage_max_setting': json['adaptive_voltage_max_setting'],
        'adaptive_voltage_min_setting': json['adaptive_voltage_min_setting'],
        'adaptive_current_max_setting': json['adaptive_current_max_setting'],
        'adaptive_current_min_setting': json['adaptive_current_min_setting'],
        'object_type': json['object_type'],
        'unique_key': json['unique_key'],
        'id': json['id'],
        'should_force_apply': json['should_force_apply'],
        '_etag': json['_etag'],
        '_ts': json['_ts'],
        'is_base_config': json['is_base_config'],
    };
}

export function PvdConfigurationOnAzureToJSON(json: any): PvdConfigurationOnAzure {
    return PvdConfigurationOnAzureToJSONTyped(json, false);
}

export function PvdConfigurationOnAzureToJSONTyped(value?: Omit<PvdConfigurationOnAzure, 'voltage_disable_allowed'|'current_disable_allowed'|'unique_key'|'is_base_config'> | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'org_code': value['org_code'],
        'spec_name': value['spec_name'],
        'is_compass_core': value['is_compass_core'],
        'voltage_allowed_settings': value['voltage_allowed_settings'],
        'adaptive_voltage_allowed': value['adaptive_voltage_allowed'],
        'current_allowed_settings': value['current_allowed_settings'],
        'adaptive_current_allowed': value['adaptive_current_allowed'],
        'adaptive_shared_auto_adapt_is_locked': value['adaptive_shared_auto_adapt_is_locked'],
        'adaptive_shared_auto_adapt_locked_to_value': value['adaptive_shared_auto_adapt_locked_to_value'],
        'adaptive_voltage_next_alert_size_is_locked': value['adaptive_voltage_next_alert_size_is_locked'],
        'adaptive_voltage_next_alert_size_locked_to_value': value['adaptive_voltage_next_alert_size_locked_to_value'],
        'adaptive_current_next_alert_size_is_locked': value['adaptive_current_next_alert_size_is_locked'],
        'adaptive_current_next_alert_size_locked_to_value': value['adaptive_current_next_alert_size_locked_to_value'],
        'adaptive_voltage_max_setting': value['adaptive_voltage_max_setting'],
        'adaptive_voltage_min_setting': value['adaptive_voltage_min_setting'],
        'adaptive_current_max_setting': value['adaptive_current_max_setting'],
        'adaptive_current_min_setting': value['adaptive_current_min_setting'],
        'object_type': value['object_type'],
        'id': value['id'],
        'should_force_apply': value['should_force_apply'],
        '_etag': value['_etag'],
        '_ts': value['_ts'],
    };
}

